import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import {
  clearChunkReloadGuard,
  isChunkRelatedFailure,
  maybeReloadOnce,
  textFromUnknown,
} from './app/core/utils/chunk-reload';

window.addEventListener('error', (event: ErrorEvent) => {
  const combined = [event.message, textFromUnknown(event.error)].filter(Boolean).join(' ');
  maybeReloadOnce('window.error', combined, event.error);
});

window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  const combined = textFromUnknown(event.reason);
  maybeReloadOnce('unhandledrejection', combined, event.reason);
});

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    clearChunkReloadGuard();
  })
  .catch((error: unknown) => {
    const combined = textFromUnknown(error);
    if (isChunkRelatedFailure(combined, error)) {
      maybeReloadOnce('bootstrap', combined, error);
      return;
    }
    console.error(error);
  });
